/**
 * Fetch con token e retry su 401 dopo refresh.
 * Usa questo per le chiamate API che richiedono autenticazione, così il token
 * viene rinnovato automaticamente quando scade mentre l'utente usa l'app.
 */
export function useAuthFetch() {
	const { accessToken, refreshAccessToken } = useAuth();

	function getToken(): string | null {
		if (process.client) {
			return accessToken.value ?? localStorage.getItem('directus_access_token');
		}
		return accessToken.value;
	}

	async function authFetch<T>(
		url: string,
		options?: Parameters<typeof $fetch>[1],
	): Promise<T> {
		const token = getToken();
		const headers = { ...(options?.headers as Record<string, string>), ...(token ? { Authorization: `Bearer ${token}` } : {}) };

		try {
			return await $fetch<T>(url, { ...options, headers });
		} catch (err: any) {
			if (err?.statusCode === 401 && token) {
				const refreshed = await refreshAccessToken();
				if (refreshed) {
					const newToken = getToken();
					return $fetch<T>(url, {
						...options,
						headers: { ...(options?.headers as Record<string, string>), ...(newToken ? { Authorization: `Bearer ${newToken}` } : {}) },
					});
				}
			}
			throw err;
		}
	}

	return { authFetch, getToken };
}
